<div class="app-layout d-flex w-100 gap-2 px-2">
  <div class="sidebar-wrapper d-flex flex-row flex-shrink-0 position-relative">
    <av-sidenav></av-sidenav>
  </div>

  <main class="content-wrapper overflow-hidden d-flex flex-column">
    <av-header class="flex-shrink-0"></av-header>

    <div class="main-content overflow-auto d-block px-3 pb-3">
      <router-outlet />
    </div>
  </main>
</div>

<av-footer></av-footer>
